import { render, staticRenderFns } from "./IndustryMatchesSection.vue?vue&type=template&id=45c6e87f&scoped=true"
import script from "./IndustryMatchesSection.vue?vue&type=script&lang=js"
export * from "./IndustryMatchesSection.vue?vue&type=script&lang=js"
import style0 from "./IndustryMatchesSection.vue?vue&type=style&index=0&id=45c6e87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6e87f",
  null
  
)

export default component.exports